<template>
    <div>
        <div v-show="isLoading">
            <div class="fa-3x text-purple centerLoad">
                <i class="fas fa-spinner fa-pulse"></i>
            </div>
        </div>
        <iframe v-show="!isLoading"
                class="calendlyFull w-100"
                :src="iframe"
                frameborder="0"
                @load="iframeLoaded()"></iframe>
    </div>
</template>

<script>
export default {
    props: ['iframe'],
    data() {
        return {
            isLoading: true
        }
    },
    methods: {
        iframeLoaded() {
            this.isLoading = false
        },
        closeModal() {
            this.$emit('close')
        }
    },
    mounted() {
        this.isLoading = true
    }
}

</script>

<style scoped>
    iframe {
        min-height: 650px;
        height: 100%;
    }

    .centerLoad {
        width: 40px;
        margin: 200px auto !important;
    }
</style>
